import { consumer, core } from '@tock/coretypes';
import _ from 'lodash';

export type OfferingSingleSlugDashboard =
  | 'experience'
  | 'event'
  | 'special-table'
  | 'togo'
  | 'tableside-menu';
const varietyToSingleSlugDashboard: {
  [K in core.TicketType.Variety | consumer.Offering.Type]: OfferingSingleSlugDashboard;
} = {
  DEPOSIT: 'experience',
  FULL: 'experience',
  PRIX_FIXE: 'experience',
  RESERVATION: 'experience',
  DEPRECATED_EVENT: 'event',
  GA_EVENT: 'event',
  SEATED_EVENT: 'event',
  DEPRECATED_SPECIAL_TABLE: 'special-table',
  ORDER_DELIVERY: 'togo',
  ORDER_PICKUP: 'togo',
  TABLESIDE: 'tableside-menu', // todo (Blake) revisit if splitting section
};
export const ALL_OFFERING_SINGLE_SLUGS_DASHBOARD = _.uniq(_.values(varietyToSingleSlugDashboard));

/**
 * Returns the slug for a single one of the offering type
 */
export function offeringSingleSlugDashboard(
  variety: core.TicketType.Variety | consumer.Offering.Type
) {
  return varietyToSingleSlugDashboard[variety];
}
